module.exports = __webpack_public_path__ + "static/media/proposal.bcbbbe60.jpg";